<template>
  <v-dialog v-model="dialog" persistent max-width="600">
    <template>
      <v-card>
        <v-toolbar color="orange">
          Accredit student
          <v-spacer></v-spacer>
          <v-btn icon @click="closeDialog">
            <v-icon>mdi-close-circle</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-form
            class="mt-5"
            v-model="findStudentFormValid"
            @submit.prevent="findStudent"
          >
            <v-text-field
              outlined
              label="Matriculation Number *"
              prepend-inner-icon="mdi-school"
              v-model="registrationNumber"
              hide-details
              clearable
            ></v-text-field>

            <v-btn
              large
              :loading="finding"
              :disabled="finding"
              class="mt-3"
              type="submit"
              color="primary"
              outlined
            >
              Find Student <v-icon right>mdi-account-search-outline</v-icon>
              <template v-slot:loader>
                <span>Finding...</span>
              </template>
            </v-btn>
          </v-form>
          <section v-if="found">
            <v-divider class="my-5"></v-divider>
            <table class="table">
              <tbody>
                <tr>
                  <td>Matriculation Number</td>
                  <td>{{ student.matric }}</td>
                </tr>
                <tr>
                  <td>Full Name &mdash; (Gender)</td>
                  <td>{{ student.name }} &mdash; ({{ student.gender }})</td>
                </tr>
                <!-- <tr>
                          <td>Gender</td>
                          <td>{{ student.gender }}</td>
                        </tr> -->
                <tr>
                  <td>Course of Study</td>
                  <td>{{ student.course }}</td>
                </tr>
                <tr>
                  <td>Department</td>
                  <td>{{ student.department }}</td>
                </tr>
                <tr>
                  <td>Faculty</td>
                  <td>{{ student.faculty }}</td>
                </tr>
              </tbody>
            </table>
            <table class="table mt-4">
              <tbody>
                <tr>
                  <td>Last Registration</td>
                  <td>
                    {{
                      student.lastRegistration.semesterRegistered == 1
                        ? "First"
                        : "Second"
                    }}
                    Semester, {{ student.lastRegistration.sessionRegistered }}
                  </td>
                </tr>
                <tr>
                  <td>Last Registration Date</td>
                  <td>{{ student.lastRegistration.dateRegistered }}</td>
                </tr>
              </tbody>
            </table>
          </section>
        </v-card-text>
        <v-card-actions v-if="found" class="pa-6">
          <v-btn
            large
            class="px-5"
            color="secondary"
            @click="addStudentToVoters"
            :loading="accrediting"
          >
            Accredit Student
            <v-icon right>mdi-account-plus</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </template>
  </v-dialog>
</template>

<script>
export default {
  data: () => ({
    dialog: false,
    finding: false,
    accrediting: false,
    found: false,
    student: {},
    registrationNumber: null,
    findStudentFormValid: false,
    election: null,
  }),

  watch: {
    registrationNumber(val) {
      if (val) this.registrationNumber = val.toUpperCase();
    },
  },
  methods: {
    openForm(election) {
      this.election = election;
      this.dialog = true;
    },
    findStudent() {
      if (!this.registrationNumber) return;

      this.finding = true;
      this.found = false;

      this.$axios
        .get("/student", { params: { registration: this.registrationNumber } })
        .then(({ data: { data: student } }) => {
          this.student = student;
          this.found = true;
        })
        .catch((error) => {
          console.log(error);

          this.found = false;

          this.$bus.$emit("snackbar", {
            type: "error",
            message: "Student not found",
          });
        })
        .finally(() => {
          this.finding = false;
        });
    },
    closeDialog() {
      this.found = false;
      this.dialog = false;
    },
    addStudentToVoters() {
      this.accrediting = true;

      this.$axios({
        url: "/beta/accredit-student",
        method: "POST",
        data: {
          student: this.student.id,
          election: this.election,
        },
      })
        .then(() => {
          this.$bus.$emit("election.updated");
          this.closeDialog();
        })
        .catch((error) => {
          if (error.response.status == 402) {
            this.$bus.$emit("snackbar", {
              type: "warning",
              message: "Student did not register for election session",
            });
          } else if (error.response.status == 412) {
            this.$bus.$emit("snackbar", {
              type: "warning",
              message: "Student may have been accredited already",
            });
          } else {
            this.$bus.$emit("snackbar", {
              type: "error",
              message: "Could not accredit student",
            });
          }
        })
        .finally(() => {
          this.accrediting = false;
        });
    },
  },

  mounted() {
    this.$bus.$on("voters.student.add", this.openForm);
  },
};
</script>

<style lang="scss" scoped>
.table {
  width: 100%;
  border-collapse: collapse;

  thead {
    tr {
      th {
        text-transform: uppercase;
      }
    }
  }

  tr {
    border-left: 5px solid #c3e7cd;
    border-left: 5px solid #eee1ad;
    border-bottom: thin solid #dddddd;
  }

  tr:nth-of-type(even) {
    background-color: #f3f3f3;
  }

  tr {
    th,
    td {
      padding: 0.75em 1em;
      margin: 0;
    }

    th {
      text-align: left;
    }

    td:nth-child(2) {
      font-weight: 500;
      text-align: right;
    }
  }
}
</style>